const m = "pdlt-mention",
  u = ["user"];
class o extends HTMLElement {
  /**
   * Create a new PdltMention element from a set of attributes.
   */
  static fromAttributes(_ref) {
    let {
      type: e,
      mentioner: t,
      mentionee: n
    } = _ref;
    if (window.customElements.get(m) == null) throw Error("PdltMention is not registered yet");
    const i = new o();
    return i.setAttribute("type", e), i.setAttribute("mentioner-id", t.hashid), i.setAttribute("mentionee-id", n.hashid), i.setAttribute("mentionee-username", n.username), i.textContent = n.display_name, i;
  }
  /**
   * Create a new PdltMention element from an HTML string.
   */
  static fromString(e) {
    if (window.customElements.get(m) == null) throw Error("PdltMention is not registered yet");
    const t = document.createElement("template");
    if (t.innerHTML = e, t.innerHTML !== e) return null;
    const n = t.content.firstElementChild;
    if (n === null) return null;
    const i = {
        type: n.getAttribute("type"),
        "mentioner-id": n.getAttribute("mentioner-id"),
        "mentionee-id": n.getAttribute("mentionee-id"),
        "mentionee-username": n.getAttribute("mentionee-username"),
        mentioneeDisplayName: n.textContent
      },
      s = new o();
    return Object.entries(i).forEach(_ref2 => {
      let [l, r] = _ref2;
      l === "mentioneeDisplayName" ? r !== null && (s.textContent = r) : r !== null && s.setAttribute(l, r);
    }), s;
  }
  get isValid() {
    return this.type === "user" ? this.mentionerId !== null && this.mentioneeId !== null && this.mentioneeUsername !== null && this.mentioneeDisplayName !== "" : !1;
  }
  get type() {
    const e = this.getAttribute("type");
    if (e === null) return null;
    const t = e;
    return u.includes(t) ? t : null;
  }
  get mentionerId() {
    return this.getAttribute("mentioner-id");
  }
  get mentioneeId() {
    return this.getAttribute("mentionee-id");
  }
  get mentioneeUsername() {
    return this.getAttribute("mentionee-username");
  }
  get mentioneeDisplayName() {
    return this.textContent;
  }
  toString() {
    return this.outerHTML;
  }
  connectedCallback() {
    this.type === "user" && this.renderProfileLink();
  }
  renderProfileLink() {
    var e;
    if (this.mentioneeUsername != null && this.mentioneeUsername !== "") {
      const t = `https://${window.location.hostname}/${this.mentioneeUsername}`;
      this.innerHTML = `<a href="${t}" target="_blank" data-bridged-link="profile" data-bridged-link-username="${this.mentioneeUsername}">${(e = this.mentioneeDisplayName) != null ? e : "User"}</a>`;
    }
  }
}
export { m as MENTION_ELEMENT_TAG_NAME, o as PdltMention };